import { doGraphqlRequest } from 'ducks/requests'
import graphql from '../api'
import * as types from '../types'

const fetchOrdersQuery = `
  query ShopifyFetchOrders(
    $customerId: ID!,
    $limit: Int!
  ) {
    customer(id: $customerId) {
      id
      orders(first: $limit) {
        edges {
          node {
            id
            createdAt
            fullyPaid
            name
            unpaid
            requiresShipping
            lineItems(first: 10) {
              edges {
                node {
                  id
                  name
                  discountedTotalSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                  currentQuantity
                }
              }
            }

            displayFinancialStatus
            displayFulfillmentStatus

            fulfillments {
              id
              displayStatus
              trackingInfo {
                company
                number
                url
              }
            }

            currentSubtotalPriceSet {
              shopMoney {
                amount
                currencyCode
              }
            }

            currentTotalTaxSet {
              shopMoney {
                amount
                currencyCode
              }
            }

            currentTotalDiscountsSet {
              shopMoney {
                amount
                currencyCode
              }
            }

            currentTotalDutiesSet {
              shopMoney {
                amount
                currencyCode
              }
            }

            currentTotalPriceSet {
              shopMoney {
                amount
                currencyCode
              }
            }

            totalShippingPriceSet {
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`

const doFetchOrders = (integrationId, customerGid, limit) => dispatch => {
  const variables = { customerId: customerGid, limit }
  dispatch(
    doGraphqlRequest(types.FETCH_ORDERS_REQUEST, fetchOrdersQuery, variables, {
      graphqlFunc: graphql(integrationId),
    })
  )
}

export default doFetchOrders
